export const formatTime = (timestamp, language, timezone) => {
  return new Intl.DateTimeFormat(language, {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: timezone || undefined,
  }).format(new Date(timestamp))
}

export const formatDateLabel = (timestamp, language, timezone) => {
  return new Intl.DateTimeFormat(language, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: timezone || undefined,
  })
    .format(new Date(timestamp))
    .toUpperCase()
}

const getDateKey = (timestamp, timezone) => {
  if (!timezone) return new Date(timestamp).toISOString().split('T')[0]

  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timezone,
  }).format(new Date(timestamp))
}

export const groupEventsByDate = (events, language, timezone) => {
  const groups = {}

  events.forEach(event => {
    const date = getDateKey(event.timestamp, timezone)

    if (!groups[date]) {
      groups[date] = {
        date,
        label: formatDateLabel(event.timestamp, language, timezone),
        events: [],
      }
    }

    groups[date].events.push({
      ...event,
      time: formatTime(event.timestamp, language, timezone),
    })
  })

  return Object.values(groups)
    .sort((a, b) => b.date.localeCompare(a.date))
    .map(group => ({
      ...group,
      events: group.events.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)),
    }))
}
